import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import configuration from '@/composables/config';
import { getBusinessAreas } from '@/composables/businessareas';
import { useCompanyStore } from '@/store/companies';
import { useBusinessareasStore } from '@/store/businessareas';
import { computed, ref, watch, withDefaults } from 'vue';
import _ from 'lodash';
import { Businessarea, Maybe, BusinessareaType } from '@/graphql/types/graphql';
import { useI18n } from 'vue-i18n';

interface BusinessareaSelectorProps {
    type?: string;
    value?: Maybe<Businessarea>;
    clear?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessareaSelector',
  props: {
    type: { default: 'edit' },
    value: { default: null },
    clear: {}
  },
  emits: ['select'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const emit = __emit;

let companyStore = useCompanyStore();
let businessareasStore = useBusinessareasStore();
let search = ref('');

let selectedType = ref(getInitialType());

const props = __props;

function isDisabled() {
    if (props.type === 'editTalent') {
        return false;
    }
    return !selectedType.value;
}

function getInitialType() {
    if (props.type === 'edit') {
        if (companyStore.userCompany?.businessArea) {
            return t(
                (companyStore.userCompany.businessArea.type as string).toLowerCase()
            );
        }
    } else {
        if (props.value) {
            return t((props.value.type as string).toLowerCase());
        }
    }
    return null;
}

const types = Object.values(BusinessareaType)
    .filter((el) => {
        return (el as string).toLowerCase() !== 'agency';
    })
    .map((el) => ({
        label: t(`business_area_${(el as string).toLowerCase()}`),
        value: el,
    }));

const typesList = types.map((el) => el.label);

const model = computed({
    get() {
        if (props.type === 'edit') {
            return companyStore.userCompany?.businessArea?.description;
        } else {
            return props.value?.description;
        }
    },
    set(newValue) {
        const businessArea = _.find(businessareasStore.businessareas, {
            description: newValue,
        }) as Businessarea;
        if (props.type === 'edit') {
            companyStore.userCompany.businessArea = businessArea;
        } else {
            emit('select', businessArea);
        }
    },
});

watch(
    () => selectedType.value,
    (value) => {
        const type = types.find((el) => (el as any).label === value);
        if (type) {
            businessareasStore.resetFiltered(type.value);
            if (props.type === 'edit') {
                companyStore.userCompany.businessArea = null;
            } else {
                emit('select', null);
            }
        }
    }
);

watch(search, (value) => {
    const type = types.find((el) => (el as any).label === selectedType?.value);
    if (_.isString(value) && value.length > 2) {
        businessareasStore.filter(value, type?.value);
    } else {
        businessareasStore.resetFiltered(type?.value);
    }
});

getBusinessAreas();

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", null, [
    (props.type !== 'editTalent')
      ? (_openBlock(), _createBlock(_component_v_select, {
          key: 0,
          modelValue: _unref(selectedType),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedType) ? (selectedType).value = $event : selectedType = $event)),
          items: _unref(typesList),
          class: "mt-8 mb-8",
          label: `${_ctx.$t('typology')} *`,
          variant: "underlined",
          "hide-details": "",
          color: "primary"
        }, null, 8, ["modelValue", "items", "label"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_autocomplete, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
      search: _unref(search),
      "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event)),
      disabled: isDisabled(),
      items: _unref(businessareasStore).filtered,
      "hide-no-data": "",
      underlined: "",
      clearable: true,
      "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (
                props.type !== 'editTalent'
                    ? (_unref(companyStore).userCompany.businessArea = null)
                    : props.clear()
            )),
      "hide-selected": "",
      color: "primary",
      class: "no-padding-start",
      label: `${_ctx.$t('businessarea')} *`,
      placeholder: `${_ctx.$t('businessarea')}`
    }, null, 8, ["modelValue", "search", "disabled", "items", "label", "placeholder"])
  ]))
}
}

})